<template>
  <div id="app">
    <my-header></my-header>
    <router-view v-if="isRouterAlive"></router-view>
    <my-footer></my-footer>
    <!--回到顶部-->
    <BackTop></BackTop>
  </div>
</template>

<script>
  import myHeader from './components/common/myHeader'
  import myFooter from './components/common/myFooter'

  export default {
    name: 'App',
    components: {myHeader,myFooter},
    provide(){
      return{
        reload: this.reload
      }
    },
    data(){
      return{
        isRouterAlive: true,
      }
    },
    methods: {
      reload(){
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true;
        });
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue